import deleteTemplate from "emun.retailer/retailer-payment-method-delete-confirmation.htm";
import fieldsetTemplate from "emun.retailer/retailer-payment-method-fieldset.htm";
import $session from "servicestack/session";
import { ModelPrompt, ModelPromptController } from "webmodals/model-prompt";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";
import modals from "webmodals/modals";
export class RetailerPaymentMethodPromptController extends ModelPromptController {
  constructor($uibModalInstance, options, $sce) {
    super(options);
    const $ctrl = this;
    $ctrl.modal = $uibModalInstance;
    $ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
    $ctrl.$close = $ctrl.close = $uibModalInstance.close;
    $ctrl.$geo = $ctrl.$ioc("$geo");
    $ctrl.cartConfig = cartConfig;
    $ctrl.useHostedPCI = $ctrl.cartConfig.useHostedPCI();
    $ctrl.hostName = window.location.protocol + "//" + window.location.hostname;
    if ($ctrl.hostName.indexOf("localhost") > -1) $ctrl.hostName = $ctrl.hostName + ":" + window.location.port;
    console.debug("BL*** port", window.location.port);
    console.debug("BL*** hostname", $ctrl.hostName);
    $ctrl.hpciIframeUrl = $sce.trustAsResourceUrl(`https://cci.framehpci.com/iSynSApp/showPxyPage!ccFrame.action?pgmode1=prod&locationName=checkout1&sid=534961&reportCCType=Y&reportCCDigits=Y&formatCCDigits=Y&formatCCDigitsDelimiter=-&reportCVVDigits=Y&formatCCMaskMode=S6X6&formatCCMaskChar=*&enableEarlyToken=Y&reportInit=Y&fullParentHost=${$ctrl.hostName}&fullParentQStr=/#/checkout`);
    console.debug("BL*** hpciIframeUrl", $ctrl.hpciIframeUrl);
  }

  submit() {
    let $ctrl = this;
    if ($ctrl.useHostedPCI && $ctrl.commandUrl == "CreateRetailerPaymentMethod.json") {
      var ccNumInput = document.getElementById("cc-token");
      var ccTypeInput = document.getElementById("cc-type");
      var ccLastFour = document.getElementById("cc-last4");
      console.debug("BL*** cc token", ccNumInput.value);
      if (!ccNumInput.value) {
        modals.alert("Invalid credit card #");
        return;
      } 
      $ctrl.request.tokenizationProvider = "HostedPCI";
      $ctrl.request.tokenizationCode = ccNumInput.value;
      $ctrl.request.number = "TOKEN";
      $ctrl.request.type = ccTypeInput.value;
      $ctrl.request.network = ccTypeInput.value;
      $ctrl.request.provider = ccTypeInput.value;
      $ctrl.request.lastFour = ccLastFour.value;
      $ctrl.request.isPrimary = true;
    }
    $ctrl.bus.send($ctrl.commandUrl, $ctrl.prompt.mapModel($ctrl.request)).then(
      (r) => $ctrl.onSuccess(r),
      (r) => $ctrl.onFailed(r)
    );
    //$ctrl.prompt.validate($ctrl.request).then(function () {
    //	if ($ctrl.valid) {
    //		$ctrl.bus
    //			.send($ctrl.commandUrl, $ctrl.prompt.mapModel($ctrl.request))
    //			.then(r => $ctrl.onSuccess(r), r => $ctrl.onFailed(r));
    //	}
    //});
  }

  $onInit() {
    const $ctrl = this;
    if ($ctrl.request.retailerId) {
      ServiceBus.send(
        "QueryRetailers.json?RetailerId=" + $ctrl.request.retailerId
      ).then((res) => {
        if (res.data.results.length > 0) {
          $ctrl.retailer = res.data.results[0];
        }
      });
    }
  }

  toggleSameAsBilling() {
    const $ctrl = this;
    if ($ctrl.sameAsBilling) {
      $ctrl.copyFromBilling();
    } else {
      $ctrl.request.address = "";
      $ctrl.request.city = "";
      $ctrl.request.state = "";
      $ctrl.request.zip = "";
      $ctrl.request.country = "";
    }
  }

  copyFromBilling() {
    const $ctrl = this;
      $ctrl.request.address = $ctrl.retailer.billingLocation.address;
      $ctrl.request.city = $ctrl.retailer.billingLocation.city;
      $ctrl.request.state = $ctrl.retailer.billingLocation.state;
      $ctrl.request.zip = $ctrl.retailer.billingLocation.zip;
      $ctrl.request.country = $ctrl.retailer.billingLocation.country;
  }

}

export default class RetailerPaymentMethodPrompt extends ModelPrompt {
  $oninit() {
    const $ctrl = this;
    $ctrl.seed = {
      status: "Active",
      retailerId: $session.retailerId,
      country: "US",
      salesReps: [$session.salesRepId || $session.userAuthName],
    };
  }
  getTitle(model, action) {
    return `${action} payment method...`;
  }
  getQueryUrl(model, action) {
    return `QueryRetailerPaymentMethods.json?EncryptedNumber=${
      model && encodeURIComponent(model.encryptedNumber)
    }`;
  }
  getCommandUrl(model, action) {
    return `${action}RetailerPaymentMethod.json`;
  }
  getModalBodyTemplateUrl(model, action) {
    return action === "Delete" ? deleteTemplate : fieldsetTemplate;
  }
  mapModel(model, action) {
    const m = Object.assign(model);
    delete m.expiration;
    delete m.expiresOn;
    return m;
  }
  getController(model, action) {
    return RetailerPaymentMethodPromptController;
  }
}
